import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelectSync, { OptionType } from '@nxsys/components/AppSelectSync';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';

type Props = {
  onSave: (values: any) => void;
  isOpen: boolean;
  toggle: () => void;
};

const ProcessStatutoryModal: React.FC<Props> = ({ onSave, toggle, isOpen }) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();

  const onFinish: FormProps['onFinish'] = (values) => {
    console.log('Success:', values);
    onSave({ ...values });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages["statutory.form.selectAgency"]}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages["common.cancel"],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages["common.save"],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      minHeight='200px'
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label={messages["statutory.form.agencyName"]}
          name="agencyName"
          rules={[{ required: true, message: messages["statutory.form.pleaseSelectAgency"] }]}
        >
          <AppSelectSync
            type="agency"
            apiType="searchAgency"
            placeholder={messages["statutory.form.selectAgency"]}
            onChangeValue={(value: OptionType | OptionType[] | null) => {
              form.setFieldsValue({
                agencyName: value,
              });
            }}
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default ProcessStatutoryModal;
